// @ts-nocheck
import "./ChallengeEngine.css";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Button from "../../../shared/components/Button";
import { siteTexts } from "../../../shared/i18n/siteTexts";
import { apiRequest } from "../../../shared/lib/api";

const QUADRAS = 2;
const MAX_JOGOS_SEGUIDOS = 2;
const MAX_FOLGAS_SEGUIDAS = 1;
const DEFAULT_CHALLENGE_KEY = "challenge";
const SUPER8_PLAYERS = 8;
const SUPER8_ROUNDS = 7;

function defaultDuplasPorGrupo() {
  return { [DEFAULT_CHALLENGE_KEY]: [] };
}

function defaultModoDuplasPorGrupo() {
  return { [DEFAULT_CHALLENGE_KEY]: "fixas" };
}

function defaultJogadoresPorGrupo() {
  return { [DEFAULT_CHALLENGE_KEY]: [] };
}

function defaultJogosPorGrupo() {
  return { [DEFAULT_CHALLENGE_KEY]: [] };
}

function defaultTorneiosPorGrupo() {
  return { [DEFAULT_CHALLENGE_KEY]: null };
}

function normalizarLados(lado) {
  if (!lado) return { direita: true, esquerda: false };
  if (typeof lado === "string") {
    if (lado === "ambos") return { direita: true, esquerda: true };
    return {
      direita: lado === "direita",
      esquerda: lado === "esquerda",
    };
  }
  return {
    direita: Boolean(lado.direita),
    esquerda: Boolean(lado.esquerda),
  };
}

function formatarLados(lado) {
  const lados = normalizarLados(lado);
  if (lados.direita && lados.esquerda) {
    return siteTexts.challengeEngine.labels.rightAndLeft;
  }
  if (lados.direita) return siteTexts.challengeEngine.labels.right;
  if (lados.esquerda) return siteTexts.challengeEngine.labels.left;
  return siteTexts.challengeEngine.labels.undefined;
}

function parseLadoSalvo(valor) {
  if (!valor) return null;
  if (typeof valor === "string") {
    try {
      const parsed = JSON.parse(valor);
      return normalizarLados(parsed);
    } catch (_erro) {
      return normalizarLados(valor);
    }
  }
  return normalizarLados(valor);
}
function buildAuthRequestOptions(options = {}) {
  const token = localStorage.getItem("tnp-token") || "";
  return {
    ...options,
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  };
}

async function salvarPreferenciaLadoNoBanco(cpf, lado) {
  try {
    await apiRequest(
      `/api/players/${cpf}/side`,
      buildAuthRequestOptions({
        method: "PUT",
        body: JSON.stringify({ lado }),
      }),
    );
  } catch (erro) {
    console.warn(siteTexts.challengeEngine.saveSideError, erro);
  }
}

async function salvarDuplaNoBanco(grupo, cpf1, cpf2) {
  try {
    await apiRequest(
      "/api/pairs",
      buildAuthRequestOptions({
        method: "POST",
        body: JSON.stringify({ group: grupo, cpf1, cpf2 }),
      }),
    );
  } catch (erro) {
    console.warn(siteTexts.challengeEngine.savePairError, erro);
  }
}

async function criarTorneioNoBanco(grupo, rodadas) {
  try {
    const data = await apiRequest(
      "/api/tournaments",
      buildAuthRequestOptions({
        method: "POST",
        body: JSON.stringify({ group: grupo, rounds: rodadas }),
      }),
    );
    return data.id;
  } catch (erro) {
    console.warn(siteTexts.challengeEngine.createTournamentError, erro);
    return null;
  }
}

async function atualizarRodadasNoBanco(torneioId, rodadas) {
  try {
    await apiRequest(
      `/api/tournaments/${torneioId}/rounds`,
      buildAuthRequestOptions({
        method: "PUT",
        body: JSON.stringify({ rounds: rodadas }),
      }),
    );
    return true;
  } catch (erro) {
    console.warn(siteTexts.challengeEngine.createTournamentError, erro);
    return false;
  }
}

async function finalizarTorneioNoBanco(torneioId, duracaoSegundos, rodadas) {
  try {
    await apiRequest(
      `/api/tournaments/${torneioId}/finalize`,
      buildAuthRequestOptions({
        method: "PUT",
        body: JSON.stringify({
          durationSeconds: duracaoSegundos,
          rounds: rodadas,
        }),
      }),
    );
  } catch (erro) {
    console.warn(siteTexts.challengeEngine.finalizeTournamentError, erro);
  }
}

function gerarJogos(lista) {
  let jogos = [];
  for (let i = 0; i < lista.length; i++) {
    for (let j = i + 1; j < lista.length; j++) {
      jogos.push({
        dupla1Id: lista[i].id,
        dupla2Id: lista[j].id,
        score1: "",
        score2: "",
      });
    }
  }
  return jogos;
}

function embaralhar(lista) {
  const copia = [...lista];
  for (let i = copia.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copia[i], copia[j]] = [copia[j], copia[i]];
  }
  return copia;
}

function montarDuplasSorteadas(jogadores) {
  const lista = jogadores
    .filter((jogador) => jogador && jogador.cpf)
    .map((jogador) => ({
      ...jogador,
      lados: normalizarLados(jogador.lado),
    }));
  if (lista.length % 2 !== 0) {
    return { erro: siteTexts.challengeEngine.requiresEvenPlayers };
  }

  const esquerda = embaralhar(
    lista.filter((jogador) => jogador.lados.esquerda && !jogador.lados.direita),
  );
  const direita = embaralhar(
    lista.filter((jogador) => jogador.lados.direita && !jogador.lados.esquerda),
  );
  const ambos = embaralhar(
    lista.filter((jogador) => jogador.lados.direita && jogador.lados.esquerda),
  );

  const duplas = [];
  let conflitoLado = false;

  while (esquerda.length > 0 && direita.length > 0) {
    duplas.push([esquerda.pop(), direita.pop()]);
  }

  if (esquerda.length > direita.length) {
    while (esquerda.length > 0 && ambos.length > 0) {
      duplas.push([esquerda.pop(), ambos.pop()]);
    }
  } else if (direita.length > esquerda.length) {
    while (direita.length > 0 && ambos.length > 0) {
      duplas.push([ambos.pop(), direita.pop()]);
    }
  }

  while (esquerda.length >= 2) {
    conflitoLado = true;
    duplas.push([esquerda.pop(), esquerda.pop()]);
  }

  while (direita.length >= 2) {
    conflitoLado = true;
    duplas.push([direita.pop(), direita.pop()]);
  }

  while (ambos.length >= 2) {
    duplas.push([ambos.pop(), ambos.pop()]);
  }

  if (esquerda.length || direita.length || ambos.length) {
    return { erro: siteTexts.challengeEngine.unableToBuildPairs };
  }

  return { duplas: embaralhar(duplas), conflitoLado };
}

function jogosCompativeis(j1, j2) {
  return (
    j1.dupla1Id !== j2.dupla1Id &&
    j1.dupla1Id !== j2.dupla2Id &&
    j1.dupla2Id !== j2.dupla1Id &&
    j1.dupla2Id !== j2.dupla2Id
  );
}

function atualizarEstado(estado, duplas, jogando) {
  const proximo = {};
  for (const dupla of duplas) {
    const estaJogando = jogando.has(dupla);
    const jogosSeguidos = estaJogando ? estado[dupla].play + 1 : 0;
    const folgasSeguidas = estaJogando ? 0 : estado[dupla].idle + 1;

    if (
      jogosSeguidos > MAX_JOGOS_SEGUIDOS ||
      folgasSeguidas > MAX_FOLGAS_SEGUIDAS
    ) {
      return null;
    }

    proximo[dupla] = { play: jogosSeguidos, idle: folgasSeguidas };
  }
  return proximo;
}

function montarRodadas(lista, quadras = QUADRAS) {
  const jogos = gerarJogos(lista);
  const ids = lista.map((dupla) => dupla.id);
  const minRodadas = Math.ceil(jogos.length / quadras);
  const maxRodadas = minRodadas + 2;

  for (
    let totalRodadas = minRodadas;
    totalRodadas <= maxRodadas;
    totalRodadas++
  ) {
    const rodadas = tentarMontarRodadas(
      embaralhar(jogos),
      ids,
      quadras,
      totalRodadas,
    );
    if (rodadas) return rodadas;
  }

  const fallback = [];
  const embaralhados = embaralhar(jogos);
  for (let i = 0; i < embaralhados.length; i += quadras) {
    fallback.push(embaralhados.slice(i, i + quadras));
  }
  return fallback;
}

function tentarMontarRodadas(jogos, duplas, quadras, totalRodadas) {
  const estadoInicial = {};
  duplas.forEach((dupla) => {
    estadoInicial[dupla] = { play: 0, idle: 0 };
  });

  function backtrack(indiceRodada, restantes, estadoAtual) {
    if (restantes.length === 0) return [];
    if (indiceRodada >= totalRodadas) return null;

    const rodadasRestantes = totalRodadas - indiceRodada;
    const minJogosTeorico = Math.max(
      1,
      restantes.length - (rodadasRestantes - 1) * quadras,
    );
    const maxJogosTeorico = Math.min(quadras, restantes.length);
    const isUltimaRodada = indiceRodada === totalRodadas - 1;
    let minJogos = minJogosTeorico;
    let maxJogos = maxJogosTeorico;

    if (!isUltimaRodada) {
      minJogos = Math.max(minJogos, quadras);
      maxJogos = Math.min(maxJogos, quadras);
    }

    if (minJogos > maxJogos) return null;

    const mustPlay = duplas.filter(
      (dupla) => estadoAtual[dupla].idle >= MAX_FOLGAS_SEGUIDAS,
    );
    const mustRest = new Set(
      duplas.filter((dupla) => estadoAtual[dupla].play >= MAX_JOGOS_SEGUIDOS),
    );

    if (mustPlay.length > maxJogos * 2) return null;

    const candidatos = [];
    for (let k = maxJogos; k >= minJogos; k--) {
      if (k === 1) {
        restantes.forEach((jogo) => candidatos.push([jogo]));
      } else if (k === 2) {
        for (let i = 0; i < restantes.length; i++) {
          for (let j = i + 1; j < restantes.length; j++) {
            if (jogosCompativeis(restantes[i], restantes[j])) {
              candidatos.push([restantes[i], restantes[j]]);
            }
          }
        }
      }
    }

    const candidatosEmbaralhados = embaralhar(candidatos);

    for (const rodada of candidatosEmbaralhados) {
      const jogando = new Set();
      let valido = true;

      for (const jogo of rodada) {
        if (mustRest.has(jogo.dupla1Id) || mustRest.has(jogo.dupla2Id)) {
          valido = false;
          break;
        }
        if (jogando.has(jogo.dupla1Id) || jogando.has(jogo.dupla2Id)) {
          valido = false;
          break;
        }
        jogando.add(jogo.dupla1Id);
        jogando.add(jogo.dupla2Id);
      }

      if (!valido) continue;

      if (mustPlay.some((dupla) => !jogando.has(dupla))) continue;

      const proximoEstado = atualizarEstado(estadoAtual, duplas, jogando);
      if (!proximoEstado) continue;

      const restantesNovos = restantes.filter((jogo) => !rodada.includes(jogo));
      const proximo = backtrack(
        indiceRodada + 1,
        restantesNovos,
        proximoEstado,
      );
      if (proximo) return [rodada, ...proximo];
    }

    return null;
  }

  return backtrack(0, jogos, estadoInicial);
}

function calcularRanking(duplas, jogos) {
  const confrontoDireto = (idA, idB) => {
    const jogo = jogos.find(
      (item) =>
        (item.dupla1Id === idA && item.dupla2Id === idB) ||
        (item.dupla1Id === idB && item.dupla2Id === idA),
    );
    if (!jogo) return 0;
    if (jogo.score1 === "" && jogo.score2 === "") return 0;

    const s1 = Number(jogo.score1);
    const s2 = Number(jogo.score2);
    if (Number.isNaN(s1) || Number.isNaN(s2)) return 0;

    const pontosA = jogo.dupla1Id === idA ? s1 : s2;
    const pontosB = jogo.dupla1Id === idA ? s2 : s1;
    if (pontosA === pontosB) return 0;
    return pontosA > pontosB ? 1 : -1;
  };

  return duplas
    .map((dupla) => {
      let gamesGanhos = 0;
      let gamesPerdidos = 0;
      let vitorias = 0;
      let derrotas = 0;

      jogos.forEach((jogo) => {
        const s1 = Number(jogo.score1) || 0;
        const s2 = Number(jogo.score2) || 0;

        if (jogo.dupla1Id === dupla.id) {
          gamesGanhos += s1;
          gamesPerdidos += s2;
          if (s1 > s2) vitorias++;
          if (s1 < s2) derrotas++;
        }

        if (jogo.dupla2Id === dupla.id) {
          gamesGanhos += s2;
          gamesPerdidos += s1;
          if (s2 > s1) vitorias++;
          if (s2 < s1) derrotas++;
        }
      });

      const saldoGames = gamesGanhos - gamesPerdidos;

      const jogosTotal = vitorias + derrotas;

      const duplaLabel = dupla.label || dupla;

      return {
        id: dupla.id,
        label: duplaLabel,
        gamesGanhos,
        gamesPerdidos,
        saldoGames,
        vitorias,
        derrotas,
        jogos: jogosTotal,
      };
    })
    .sort((a, b) => {
      // Ordem do ranking (Super 8):
      // 1) vitórias
      // 2) saldo de games
      // 3) games ganhos
      // 4) games perdidos (menor melhor)
      // 5) confronto direto (quando aplicável)
      // 6) desempate determinístico
      if (b.vitorias !== a.vitorias) return b.vitorias - a.vitorias;
      if (b.saldoGames !== a.saldoGames) return b.saldoGames - a.saldoGames;
      if (b.gamesGanhos !== a.gamesGanhos) return b.gamesGanhos - a.gamesGanhos;
      if (a.gamesPerdidos !== b.gamesPerdidos)
        return a.gamesPerdidos - b.gamesPerdidos;
      const confronto = confrontoDireto(a.id, b.id);
      if (confronto !== 0) return -confronto;
      const labelDiff = String(a.label || "").localeCompare(
        String(b.label || ""),
        "pt-BR",
      );
      if (labelDiff !== 0) return labelDiff;
      return String(a.id || "").localeCompare(String(b.id || ""), "pt-BR");
    });
}

function formatarTempo(segundos) {
  const horas = Math.floor(segundos / 3600);
  const minutos = Math.floor((segundos % 3600) / 60);
  const resto = segundos % 60;

  if (horas > 0) {
    return `${String(horas).padStart(2, "0")}:${String(minutos).padStart(
      2,
      "0",
    )}:${String(resto).padStart(2, "0")}`;
  }

  return `${String(minutos).padStart(2, "0")}:${String(resto).padStart(2, "0")}`;
}

function normalizarDocumento(valor) {
  return String(valor || "")
    .replace(/\D/g, "")
    .slice(0, 11);
}

function criarIdDupla(cpf1, cpf2) {
  const [a, b] = [cpf1, cpf2].sort();
  return `${a}-${b}`;
}

function labelDupla(dupla) {
  return `${dupla.nome1} / ${dupla.nome2}`;
}

function normalizarEstadoBruto(estado) {
  try {
    if (!estado || !estado.jogosPorGrupo) return null;

    const duplasLegadas =
      (estado.duplasPorGrupo?.rosa || []).length > 0
        ? estado.duplasPorGrupo?.rosa
        : estado.duplasPorGrupo?.azul || [];
    const jogosLegados =
      (estado.jogosPorGrupo?.rosa || []).length > 0
        ? estado.jogosPorGrupo?.rosa
        : estado.jogosPorGrupo?.azul || [];
    const jogadoresLegados =
      (estado.jogadoresPorGrupo?.rosa || []).length > 0
        ? estado.jogadoresPorGrupo?.rosa
        : estado.jogadoresPorGrupo?.azul || [];
    const modoLegado =
      estado.modoDuplasPorGrupo?.rosa ||
      estado.modoDuplasPorGrupo?.azul ||
      "fixas";
    const torneioLegado =
      estado.torneiosPorGrupo?.rosa || estado.torneiosPorGrupo?.azul || null;

    const estadoComDefaults = {
      ...estado,
      grupoAtual: estado.grupoAtual || DEFAULT_CHALLENGE_KEY,
      duplasPorGrupo: estado.duplasPorGrupo?.[DEFAULT_CHALLENGE_KEY]
        ? estado.duplasPorGrupo
        : { [DEFAULT_CHALLENGE_KEY]: duplasLegadas },
      jogosPorGrupo: estado.jogosPorGrupo?.[DEFAULT_CHALLENGE_KEY]
        ? estado.jogosPorGrupo
        : { [DEFAULT_CHALLENGE_KEY]: jogosLegados },
      modoDuplasPorGrupo: estado.modoDuplasPorGrupo?.[DEFAULT_CHALLENGE_KEY]
        ? estado.modoDuplasPorGrupo
        : { [DEFAULT_CHALLENGE_KEY]: modoLegado },
      jogadoresPorGrupo: estado.jogadoresPorGrupo?.[DEFAULT_CHALLENGE_KEY]
        ? estado.jogadoresPorGrupo
        : { [DEFAULT_CHALLENGE_KEY]: jogadoresLegados },
      torneiosPorGrupo: estado.torneiosPorGrupo?.[DEFAULT_CHALLENGE_KEY]
        ? estado.torneiosPorGrupo
        : { [DEFAULT_CHALLENGE_KEY]: torneioLegado },
    };

    const jogosTeste =
      estadoComDefaults.jogosPorGrupo?.[DEFAULT_CHALLENGE_KEY]?.[0]?.[0];
    if (jogosTeste && "dupla1" in jogosTeste) {
      return {
        ...estadoComDefaults,
        jogosPorGrupo: defaultJogosPorGrupo(),
      };
    }

    if (estado.cronometroAtivo && !estado.cronometroInicio) {
      return {
        ...estadoComDefaults,
        tempoBase: estado.tempoSegundos || 0,
        cronometroInicio: Date.now(),
      };
    }

    return estadoComDefaults;
  } catch (_err) {
    return null;
  }
}

function carregarEstadoSalvo() {
  try {
    const bruto = localStorage.getItem("padel-estado");
    if (!bruto) return null;
    const estado = JSON.parse(bruto);
    return normalizarEstadoBruto(estado);
  } catch (erro) {
    return null;
  }
}

function salvarEstado(estado) {
  try {
    localStorage.setItem("padel-estado", JSON.stringify(estado));
  } catch (erro) {
    // Ignorar erros de armazenamento.
  }
}

function calcularRankingSuper8(jogadores, duplas, jogos) {
  const pairById = duplas.reduce((acc, dupla) => {
    acc[dupla.id] = dupla;
    return acc;
  }, {});

  const stats = {};
  jogadores.forEach((jogador) => {
    if (!jogador?.cpf) return;
    stats[jogador.cpf] = {
      id: jogador.cpf,
      label: jogador.nome || siteTexts.challengeEngine.labels.player,
      jogos: 0,
      gamesGanhos: 0,
      gamesPerdidos: 0,
      saldoGames: 0,
      vitorias: 0,
      derrotas: 0,
    };
  });

  jogos.forEach((jogo) => {
    if (!jogo) return;
    if (jogo.score1 === "" && jogo.score2 === "") return;

    const s1 = Number(jogo.score1);
    const s2 = Number(jogo.score2);
    if (!Number.isFinite(s1) || !Number.isFinite(s2)) return;
    if (s1 === s2) return;

    const dupla1 = pairById[jogo.dupla1Id];
    const dupla2 = pairById[jogo.dupla2Id];
    if (!dupla1 || !dupla2) return;

    const jogadoresDupla1 = [dupla1.cpf1, dupla1.cpf2].filter(Boolean);
    const jogadoresDupla2 = [dupla2.cpf1, dupla2.cpf2].filter(Boolean);

    jogadoresDupla1.forEach((cpf) => {
      if (!stats[cpf]) {
        stats[cpf] = {
          id: cpf,
          label: siteTexts.challengeEngine.labels.player,
          jogos: 0,
          gamesGanhos: 0,
          gamesPerdidos: 0,
          saldoGames: 0,
          vitorias: 0,
          derrotas: 0,
        };
      }
      stats[cpf].jogos += 1;
      stats[cpf].gamesGanhos += s1;
      stats[cpf].gamesPerdidos += s2;
      if (s1 > s2) stats[cpf].vitorias += 1;
      else stats[cpf].derrotas += 1;
    });

    jogadoresDupla2.forEach((cpf) => {
      if (!stats[cpf]) {
        stats[cpf] = {
          id: cpf,
          label: siteTexts.challengeEngine.labels.player,
          jogos: 0,
          gamesGanhos: 0,
          gamesPerdidos: 0,
          saldoGames: 0,
          vitorias: 0,
          derrotas: 0,
        };
      }
      stats[cpf].jogos += 1;
      stats[cpf].gamesGanhos += s2;
      stats[cpf].gamesPerdidos += s1;
      if (s2 > s1) stats[cpf].vitorias += 1;
      else stats[cpf].derrotas += 1;
    });
  });

  const lista = Object.values(stats).map((item) => ({
    ...item,
    saldoGames: item.gamesGanhos - item.gamesPerdidos,
  }));

  return lista.sort((a, b) => {
    if (b.vitorias !== a.vitorias) return b.vitorias - a.vitorias;
    if (b.gamesGanhos !== a.gamesGanhos) return b.gamesGanhos - a.gamesGanhos;
    if (a.gamesPerdidos !== b.gamesPerdidos)
      return a.gamesPerdidos - b.gamesPerdidos;
    return String(a.label || "").localeCompare(String(b.label || ""));
  });
}

function montarRodadasSuper8(jogadores) {
  const lista = jogadores
    .filter((item) => item && item.cpf)
    .map((item) => ({
      cpf: item.cpf,
      nome: item.nome || siteTexts.challengeEngine.labels.player,
    }));
  const unique = Array.from(new Set(lista.map((item) => item.cpf))).map((cpf) =>
    lista.find((item) => item.cpf === cpf),
  );

  if (unique.length !== SUPER8_PLAYERS) {
    return { erro: "O Super 8 precisa de exatamente 8 jogadores." };
  }

  let rotating = unique.map((item) => item.cpf);
  const nameByCpf = unique.reduce((acc, item) => {
    acc[item.cpf] = item.nome;
    return acc;
  }, {});

  const duplasPorId = {};
  const rodadas = [];

  for (let round = 0; round < SUPER8_ROUNDS; round++) {
    const roundPairs = [];
    for (let i = 0; i < 4; i++) {
      const a = rotating[i];
      const b = rotating[7 - i];
      const id = criarIdDupla(a, b);
      roundPairs.push({ id, a, b });
      if (!duplasPorId[id]) {
        duplasPorId[id] = {
          id,
          cpf1: id.split("-")[0],
          cpf2: id.split("-")[1],
          nome1:
            nameByCpf[id.split("-")[0]] ||
            siteTexts.challengeEngine.labels.player,
          nome2:
            nameByCpf[id.split("-")[1]] ||
            siteTexts.challengeEngine.labels.player,
        };
      }
    }

    rodadas.push([
      {
        dupla1Id: roundPairs[0].id,
        dupla2Id: roundPairs[1].id,
        score1: "",
        score2: "",
      },
      {
        dupla1Id: roundPairs[2].id,
        dupla2Id: roundPairs[3].id,
        score1: "",
        score2: "",
      },
    ]);

    const fixed = rotating[0];
    const rest = rotating.slice(1);
    rest.unshift(rest.pop());
    rotating = [fixed, ...rest];
  }

  return { duplas: Object.values(duplasPorId), rodadas };
}

function gerarRelatorioExcel(
  grupo,
  jogosPorGrupo,
  duplasPorGrupo,
  duracaoSegundos,
  jogadoresDoGrupo,
  modoSuper8,
) {
  const agora = new Date();
  const data = agora.toISOString().slice(0, 10);
  const duracao = formatarTempo(duracaoSegundos);

  const rodadas = jogosPorGrupo[grupo] || [];
  const jogos = rodadas.flat();
  const duplas = duplasPorGrupo[grupo] || [];
  const duplasComLabel = duplas.map((dupla) => ({
    ...dupla,
    label: labelDupla(dupla),
  }));
  const ranking = modoSuper8
    ? calcularRankingSuper8(jogadoresDoGrupo || [], duplasComLabel, jogos)
    : calcularRanking(duplasComLabel, jogos);

  const separador = "\t";
  const csvEscape = (valor) => {
    if (valor === null || valor === undefined) return "";
    const texto = String(valor);
    if (
      texto.includes(separador) ||
      texto.includes('"') ||
      texto.includes("\n")
    ) {
      return `"${texto.replace(/"/g, '""')}"`;
    }
    return texto;
  };

  const linhas = [];
  linhas.push(
    [
      siteTexts.challengeEngine.csv.group,
      siteTexts.challengeEngine.csv.date,
      siteTexts.challengeEngine.csv.duration,
    ].join(separador),
  );
  linhas.push(
    [csvEscape(grupo.toUpperCase()), csvEscape(data), csvEscape(duracao)].join(
      separador,
    ),
  );
  linhas.push("");
  linhas.push(
    [
      siteTexts.challengeEngine.csv.pos,
      modoSuper8
        ? siteTexts.challengeEngine.labels.player
        : siteTexts.challengeEngine.csv.pair,
      siteTexts.challengeEngine.csv.matches,
      siteTexts.challengeEngine.csv.gamesWon,
      siteTexts.challengeEngine.csv.gamesLost,
      siteTexts.challengeEngine.csv.balance,
      siteTexts.challengeEngine.csv.wins,
      siteTexts.challengeEngine.csv.losses,
    ].join(separador),
  );

  ranking.forEach((item, index) => {
    linhas.push(
      [
        index + 1,
        csvEscape(item.label),
        item.jogos,
        item.gamesGanhos,
        item.gamesPerdidos,
        item.saldoGames,
        item.vitorias,
        item.derrotas,
      ].join(separador),
    );
  });

  const conteudo = `﻿${linhas.join("\n")}`;
  const blob = new Blob([conteudo], {
    type: "text/csv;charset=utf-8;",
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${siteTexts.challengeEngine.csv.fileNamePrefix}-${grupo}-${data}.xls`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

type ChallengeEngineProps = {
  mode?: "admin" | "ranking";
  challengeType?: "challenge" | "super8" | "poco" | "tournament";
};

export default function ChallengeEngine({
  mode = "admin",
  challengeType = "challenge",
}: ChallengeEngineProps) {
  const estadoSalvo = useMemo(() => carregarEstadoSalvo(), []);
  const authAvisadoRef = useRef(false);
  const [grupoAtual, setGrupoAtual] = useState(
    estadoSalvo?.grupoAtual || challengeType,
  );
  const [tempoSegundos, setTempoSegundos] = useState(
    estadoSalvo?.tempoSegundos || 0,
  );
  const [tempoBase, setTempoBase] = useState(estadoSalvo?.tempoBase || 0);
  const [cronometroInicio, setCronometroInicio] = useState(
    estadoSalvo?.cronometroInicio || null,
  );
  const [cronometroAtivo, setCronometroAtivo] = useState(
    estadoSalvo?.cronometroAtivo || false,
  );

  const [cadastros, setCadastros] = useState(estadoSalvo?.cadastros || {});
  const [duplasPorGrupo, setDuplasPorGrupo] = useState(
    estadoSalvo?.duplasPorGrupo || defaultDuplasPorGrupo(),
  );
  const [modoDuplasPorGrupo, setModoDuplasPorGrupo] = useState(
    estadoSalvo?.modoDuplasPorGrupo || defaultModoDuplasPorGrupo(),
  );
  const [jogadoresPorGrupo, setJogadoresPorGrupo] = useState(
    estadoSalvo?.jogadoresPorGrupo || defaultJogadoresPorGrupo(),
  );
  const [jogosPorGrupo, setJogosPorGrupo] = useState(
    estadoSalvo?.jogosPorGrupo || defaultJogosPorGrupo(),
  );
  const [torneiosPorGrupo, setTorneiosPorGrupo] = useState(
    estadoSalvo?.torneiosPorGrupo || defaultTorneiosPorGrupo(),
  );

  const [cpfDupla1, setCpfDupla1] = useState("");
  const [cpfDupla2, setCpfDupla2] = useState("");
  const [cpfJogadorSorteio, setCpfJogadorSorteio] = useState("");
  const [ladoDireita, setLadoDireita] = useState(true);
  const [ladoEsquerda, setLadoEsquerda] = useState(false);

  const resetarPartidaDoGrupo = useCallback(() => {
    setJogosPorGrupo((prev) => ({ ...prev, [grupoAtual]: [] }));
    setTorneiosPorGrupo((prev) => ({ ...prev, [grupoAtual]: null }));
    setTempoBase(0);
    setTempoSegundos(0);
    setCronometroInicio(null);
    setCronometroAtivo(false);
  }, [grupoAtual]);

  useEffect(() => {
    const handle = setTimeout(() => {
      salvarEstado({
        savedAt: Date.now(),
        grupoAtual,
        jogosPorGrupo,
        duplasPorGrupo,
        modoDuplasPorGrupo,
        jogadoresPorGrupo,
        cadastros,
        torneiosPorGrupo,
        tempoSegundos,
        tempoBase,
        cronometroInicio,
        cronometroAtivo,
      });
    }, 300);
    return () => clearTimeout(handle);
  }, [
    grupoAtual,
    jogosPorGrupo,
    duplasPorGrupo,
    modoDuplasPorGrupo,
    jogadoresPorGrupo,
    cadastros,
    torneiosPorGrupo,
    tempoSegundos,
    tempoBase,
    cronometroInicio,
    cronometroAtivo,
  ]);

  useEffect(() => {
    let cancelado = false;
    const aoAtualizar = (evento) => {
      if (evento.key !== "padel-estado") return;
      if (!evento.newValue) return;
      try {
        const estado = normalizarEstadoBruto(JSON.parse(evento.newValue));
        if (!estado) return;
        setGrupoAtual(challengeType);
        setJogosPorGrupo(estado.jogosPorGrupo);
        setDuplasPorGrupo(estado.duplasPorGrupo || defaultDuplasPorGrupo());
        setModoDuplasPorGrupo(
          estado.modoDuplasPorGrupo || defaultModoDuplasPorGrupo(),
        );
        setJogadoresPorGrupo(
          estado.jogadoresPorGrupo || defaultJogadoresPorGrupo(),
        );
        setCadastros(estado.cadastros || {});
        setTorneiosPorGrupo(
          estado.torneiosPorGrupo || defaultTorneiosPorGrupo(),
        );
        setTempoSegundos(estado.tempoSegundos || 0);
        setTempoBase(estado.tempoBase || 0);
        setCronometroInicio(estado.cronometroInicio || null);
        setCronometroAtivo(estado.cronometroAtivo || false);
      } catch (erro) {
        // Ignorar erros de parse.
      }
    };
    window.addEventListener("storage", aoAtualizar);

    const carregarSnapshotDoBanco = async () => {
      const token = localStorage.getItem("tnp-token") || "";
      if (!token) return;
      try {
        const estadoRemoto = await apiRequest(
          "/api/admin/challenge-state",
          buildAuthRequestOptions(),
        );
        if (cancelado) return;
        const normalizado = normalizarEstadoBruto(estadoRemoto);
        if (!normalizado) return;

        const localSavedAt = Number(estadoSalvo?.savedAt || 0) || 0;
        const remotoSavedAt = Number(normalizado?.savedAt || 0) || 0;
        if (remotoSavedAt && remotoSavedAt <= localSavedAt) return;

        setGrupoAtual(challengeType);
        setJogosPorGrupo(normalizado.jogosPorGrupo);
        setDuplasPorGrupo(
          normalizado.duplasPorGrupo || defaultDuplasPorGrupo(),
        );
        setModoDuplasPorGrupo(
          normalizado.modoDuplasPorGrupo || defaultModoDuplasPorGrupo(),
        );
        setJogadoresPorGrupo(
          normalizado.jogadoresPorGrupo || defaultJogadoresPorGrupo(),
        );
        setCadastros(normalizado.cadastros || {});
        setTorneiosPorGrupo(
          normalizado.torneiosPorGrupo || defaultTorneiosPorGrupo(),
        );
        setTempoSegundos(normalizado.tempoSegundos || 0);
        setTempoBase(normalizado.tempoBase || 0);
        setCronometroInicio(normalizado.cronometroInicio || null);
        setCronometroAtivo(normalizado.cronometroAtivo || false);
      } catch (_err) {
        // Sem permissão/sem token: ignora.
      }
    };

    void carregarSnapshotDoBanco();

    return () => {
      cancelado = true;
      window.removeEventListener("storage", aoAtualizar);
    };
  }, [challengeType, estadoSalvo?.savedAt]);

  useEffect(() => {
    const carregarDoBanco = async () => {
      try {
        const jogadores = await apiRequest(
          "/api/players",
          buildAuthRequestOptions(),
        );
        const cadastrosMap = jogadores.reduce((acc, item) => {
          const lado = parseLadoSalvo(item.sidePref);
          acc[item.cpf] = { cpf: item.cpf, nome: item.name, lado };
          return acc;
        }, {});

        setCadastros(cadastrosMap);

        const duplas = await apiRequest(
          `/api/pairs?group=${encodeURIComponent(challengeType)}`,
          buildAuthRequestOptions(),
        );

        const montarDupla = (dupla) => ({
          id: dupla.id,
          cpf1: dupla.cpf1,
          nome1:
            cadastrosMap[dupla.cpf1]?.nome ||
            siteTexts.challengeEngine.labels.player,
          cpf2: dupla.cpf2,
          nome2:
            cadastrosMap[dupla.cpf2]?.nome ||
            siteTexts.challengeEngine.labels.player,
        });

        setDuplasPorGrupo((prev) => {
          const hasAny = Object.values(prev).some(
            (value) => Array.isArray(value) && value.length > 0,
          );
          if (hasAny) return prev;

          const grouped = duplas.reduce((acc, dupla) => {
            const key = String(dupla.group || DEFAULT_CHALLENGE_KEY);
            if (!acc[key]) acc[key] = [];
            acc[key].push(montarDupla(dupla));
            return acc;
          }, {});

          if (!grouped[challengeType]) {
            grouped[challengeType] = [];
          }
          return grouped;
        });
      } catch (erro) {
        console.warn(siteTexts.challengeEngine.loadDataError, erro);
      }
    };

    carregarDoBanco();
  }, [challengeType]);

  const modo = mode === "ranking" ? "tela" : "admin";

  useEffect(() => {
    const token = localStorage.getItem("tnp-token") || "";
    if (!token) return;

    const handle = setTimeout(() => {
      const payload = {
        savedAt: Date.now(),
        grupoAtual,
        jogosPorGrupo,
        duplasPorGrupo,
        modoDuplasPorGrupo,
        jogadoresPorGrupo,
        cadastros,
        torneiosPorGrupo,
        tempoSegundos,
        tempoBase,
        cronometroInicio,
        cronometroAtivo,
      };

      apiRequest(
        "/api/admin/challenge-state",
        buildAuthRequestOptions({
          method: "PUT",
          body: JSON.stringify(payload),
        }),
      ).catch((err) => {
        const msg = String(err?.message || err || "");
        const normalizedMsg = msg
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        const isAuth =
          normalizedMsg.includes("Token ausente") ||
          normalizedMsg.includes("Sessao invalida") ||
          normalizedMsg.includes("Acesso restrito") ||
          msg.includes("401") ||
          msg.includes("403");
        if (isAuth && !authAvisadoRef.current) {
          authAvisadoRef.current = true;
          window.alert(siteTexts.challengeEngine.labels.adminLoginToPersist);
        }
        console.warn("Falha ao salvar challenge-state no banco:", err);
      });
    }, 1500);

    return () => clearTimeout(handle);
  }, [
    grupoAtual,
    jogosPorGrupo,
    duplasPorGrupo,
    modoDuplasPorGrupo,
    jogadoresPorGrupo,
    cadastros,
    torneiosPorGrupo,
    tempoSegundos,
    tempoBase,
    cronometroInicio,
    cronometroAtivo,
  ]);

  useEffect(() => {
    setGrupoAtual(challengeType);
  }, [challengeType]);

  useEffect(() => {
    if (!duplasPorGrupo[grupoAtual]) {
      setDuplasPorGrupo((prev) => ({ ...prev, [grupoAtual]: [] }));
    }
    if (!jogosPorGrupo[grupoAtual]) {
      setJogosPorGrupo((prev) => ({ ...prev, [grupoAtual]: [] }));
    }
    if (!jogadoresPorGrupo[grupoAtual]) {
      setJogadoresPorGrupo((prev) => ({ ...prev, [grupoAtual]: [] }));
    }
    if (!modoDuplasPorGrupo[grupoAtual]) {
      setModoDuplasPorGrupo((prev) => ({ ...prev, [grupoAtual]: "fixas" }));
    }
    if (!(grupoAtual in torneiosPorGrupo)) {
      setTorneiosPorGrupo((prev) => ({ ...prev, [grupoAtual]: null }));
    }
  }, [
    grupoAtual,
    duplasPorGrupo,
    jogosPorGrupo,
    jogadoresPorGrupo,
    modoDuplasPorGrupo,
    torneiosPorGrupo,
  ]);

  const atualizarScore = useCallback(
    (rodadaIndex, jogoIndex, campo, valor) => {
      const scoreMax = grupoAtual === "super8" ? 4 : 5;
      const texto = String(valor ?? "").trim();
      let proximoValor = "";
      if (texto !== "") {
        if (!/^\d+$/.test(texto)) return;
        let numero = Number(texto);
        if (numero > scoreMax) numero = scoreMax;
        if (numero < 0) numero = 0;
        proximoValor = numero;
      }

      setJogosPorGrupo((prev) => {
        const atuais = prev[grupoAtual] || [];
        const atualizadas = atuais.map((rodada, rIndex) => {
          if (rIndex !== rodadaIndex) return rodada;
          return rodada.map((jogo, jIndex) => {
            if (jIndex !== jogoIndex) return jogo;
            return { ...jogo, [campo]: proximoValor };
          });
        });
        return { ...prev, [grupoAtual]: atualizadas };
      });
    },
    [grupoAtual],
  );

  const iniciarCronometro = () => {
    if (!rodadasValidas) {
      window.alert(mensagemVazio);
      return;
    }
    const agora = Date.now();
    setTempoBase(0);
    setTempoSegundos(0);
    setCronometroInicio(agora);
    setCronometroAtivo(true);
  };

  const finalizarPartidas = async () => {
    if (rodadas.length === 0) return;
    const agora = Date.now();
    const totalSegundos =
      cronometroAtivo && cronometroInicio
        ? tempoBase + Math.floor((agora - cronometroInicio) / 1000)
        : tempoBase;

    setTempoSegundos(totalSegundos);
    setTempoBase(totalSegundos);
    setCronometroInicio(null);
    setCronometroAtivo(false);
    const modoSuper8 = grupoAtual === "super8";
    const jogadoresDoGrupoAtual = jogadoresPorGrupo[grupoAtual] || [];
    gerarRelatorioExcel(
      grupoAtual,
      jogosPorGrupo,
      duplasPorGrupo,
      totalSegundos,
      jogadoresDoGrupoAtual,
      modoSuper8,
    );

    const rodadasAtual = jogosPorGrupo[grupoAtual] || [];
    let torneioId = torneiosPorGrupo[grupoAtual];
    if (!torneioId) {
      torneioId = await criarTorneioNoBanco(grupoAtual, rodadasAtual);
      if (torneioId) {
        setTorneiosPorGrupo((prev) => ({
          ...prev,
          [grupoAtual]: torneioId,
        }));
      }
    }

    if (torneioId) {
      await finalizarTorneioNoBanco(torneioId, totalSegundos, rodadasAtual);
    }

    if (modoDuplas === "sorteadas") {
      const jogadores = jogadoresPorGrupo[grupoAtual] || [];
      await Promise.all(
        jogadores.map((jogador) =>
          salvarPreferenciaLadoNoBanco(jogador.cpf, jogador.lado),
        ),
      );
    }
  };

  const limparDuplasDoGrupo = () => {
    resetarPartidaDoGrupo();
    setDuplasPorGrupo((prev) => ({ ...prev, [grupoAtual]: [] }));
  };

  const sortearDuplasDoGrupo = () => {
    if (cronometroAtivo) {
      window.alert(
        siteTexts.challengeEngine.labels.finishBeforeGeneratingRounds,
      );
      return;
    }
    const jogadores = jogadoresPorGrupo[grupoAtual] || [];
    if (jogadores.length < 2) return;
    if (jogadores.length % 2 !== 0) {
      window.alert(siteTexts.challengeEngine.addEvenNumberAlert);
      return;
    }

    const resultado = montarDuplasSorteadas(jogadores);
    if (resultado.erro) {
      window.alert(resultado.erro);
      return;
    }

    const duplasSorteadas = resultado.duplas.map(([j1, j2]) => ({
      id: criarIdDupla(j1.cpf, j2.cpf),
      cpf1: j1.cpf,
      nome1: j1.nome,
      cpf2: j2.cpf,
      nome2: j2.nome,
    }));

    resetarPartidaDoGrupo();
    setDuplasPorGrupo((prev) => ({
      ...prev,
      [grupoAtual]: duplasSorteadas,
    }));

    duplasSorteadas.forEach((dupla) =>
      salvarDuplaNoBanco(grupoAtual, dupla.cpf1, dupla.cpf2),
    );

    if (resultado.conflitoLado) {
      window.alert(siteTexts.challengeEngine.unresolvedSideAlert);
    }
  };

  const gerarRodadasSuper8DoGrupo = async () => {
    if (cronometroAtivo) {
      window.alert(
        siteTexts.challengeEngine.labels.finishBeforeGeneratingRounds,
      );
      return;
    }
    const jogadores = jogadoresPorGrupo[grupoAtual] || [];
    const cpfs = Array.from(
      new Set(jogadores.map((item) => item?.cpf).filter(Boolean)),
    );
    if (cpfs.length !== SUPER8_PLAYERS) {
      window.alert("O Super 8 precisa de exatamente 8 jogadores.");
      return;
    }

    const resultado = montarRodadasSuper8(jogadores);
    if (resultado.erro) {
      window.alert(resultado.erro);
      return;
    }

    resetarPartidaDoGrupo();
    setDuplasPorGrupo((prev) => ({
      ...prev,
      [grupoAtual]: resultado.duplas,
    }));
    setJogosPorGrupo((prev) => ({
      ...prev,
      [grupoAtual]: resultado.rodadas,
    }));

    resultado.duplas.forEach((dupla) =>
      salvarDuplaNoBanco(grupoAtual, dupla.cpf1, dupla.cpf2),
    );

    await persistirRodadasNoTorneio(resultado.rodadas);
  };

  const rodadas = useMemo(
    () => jogosPorGrupo[grupoAtual] || [],
    [jogosPorGrupo, grupoAtual],
  );
  const jogos = useMemo(() => rodadas.flat(), [rodadas]);
  const duplas = useMemo(
    () => duplasPorGrupo[grupoAtual] || [],
    [duplasPorGrupo, grupoAtual],
  );
  const modoDuplas = modoDuplasPorGrupo[grupoAtual] || "fixas";
  const jogadoresDoGrupo = useMemo(
    () => jogadoresPorGrupo[grupoAtual] || [],
    [jogadoresPorGrupo, grupoAtual],
  );
  const duplasComLabel = useMemo(
    () =>
      duplas.map((dupla) => {
        const nome1 =
          cadastros[dupla.cpf1]?.nome ||
          dupla.nome1 ||
          siteTexts.challengeEngine.labels.player;
        const nome2 =
          cadastros[dupla.cpf2]?.nome ||
          dupla.nome2 ||
          siteTexts.challengeEngine.labels.player;
        return {
          ...dupla,
          nome1,
          nome2,
          label: `${nome1} / ${nome2}`,
        };
      }),
    [duplas, cadastros],
  );
  const duplasPorId = useMemo(
    () =>
      duplasComLabel.reduce((acc, dupla) => {
        acc[dupla.id] = dupla.label;
        return acc;
      }, {}),
    [duplasComLabel],
  );

  const modoSuper8 = grupoAtual === "super8";
  const cpfsSelecionados = useMemo(() => {
    const set = new Set();
    if (modoSuper8) {
      jogadoresDoGrupo.forEach((jogador) => set.add(String(jogador.cpf)));
      return set;
    }
    if (modoDuplas === "fixas") {
      duplas.forEach((dupla) => {
        set.add(String(dupla.cpf1));
        set.add(String(dupla.cpf2));
      });
      return set;
    }
    jogadoresDoGrupo.forEach((jogador) => set.add(String(jogador.cpf)));
    return set;
  }, [duplas, jogadoresDoGrupo, modoDuplas, modoSuper8]);

  const listaJogadoresOrdenada = useMemo(() => {
    return Object.values(cadastros)
      .slice()
      .sort((a, b) =>
        String(a.nome || "").localeCompare(String(b.nome || ""), "pt-BR", {
          sensitivity: "base",
        }),
      );
  }, [cadastros]);

  const listaJogadoresDisponiveis = useMemo(() => {
    return listaJogadoresOrdenada.filter(
      (jogador) => !cpfsSelecionados.has(String(jogador.cpf)),
    );
  }, [cpfsSelecionados, listaJogadoresOrdenada]);
  const ranking = useMemo(
    () =>
      modoSuper8
        ? calcularRankingSuper8(jogadoresDoGrupo, duplasComLabel, jogos)
        : calcularRanking(duplasComLabel, jogos),
    [modoSuper8, jogadoresDoGrupo, duplasComLabel, jogos],
  );
  const maxJogos = useMemo(
    () => (ranking.length ? Math.max(...ranking.map((item) => item.jogos)) : 0),
    [ranking],
  );

  const classeGrupo = "tema-azul";
  const tituloGrupo = useMemo(() => {
    if (grupoAtual === "super8")
      return siteTexts.challenges.modes.super8.title.toUpperCase();
    if (grupoAtual === "poco")
      return siteTexts.challenges.modes.poco.title.toUpperCase();
    if (grupoAtual === "tournament")
      return siteTexts.challenges.modes.tournament.title.toUpperCase();
    return siteTexts.challengeEngine.labels.challengeMode;
  }, [grupoAtual]);
  const mensagemVazio = useMemo(
    () =>
      modoSuper8
        ? siteTexts.challengeEngine.labels.startSuper8Message
        : modoDuplas === "sorteadas"
          ? siteTexts.challengeEngine.labels.startDrawMessage
          : siteTexts.challengeEngine.labels.startMessage,
    [modoDuplas, modoSuper8],
  );

  const rodadasValidas = useMemo(() => {
    if (!Array.isArray(rodadas) || rodadas.length === 0) return false;
    if (!Array.isArray(duplas) || duplas.length < 2) return false;
    const idsValidos = new Set(duplas.map((item) => item?.id).filter(Boolean));
    if (idsValidos.size < 2) return false;

    const idsPresentes = new Set();
    for (const rodada of rodadas) {
      if (!Array.isArray(rodada) || rodada.length === 0) return false;
      for (const jogo of rodada) {
        const id1 = jogo?.dupla1Id;
        const id2 = jogo?.dupla2Id;
        if (!id1 || !id2) return false;
        if (!idsValidos.has(id1) || !idsValidos.has(id2)) return false;
        idsPresentes.add(id1);
        idsPresentes.add(id2);
      }
    }

    for (const id of idsValidos) {
      if (!idsPresentes.has(id)) return false;
    }

    return true;
  }, [rodadas, duplas]);

  const podeIniciar = rodadasValidas;

  const persistirRodadasNoTorneio = useCallback(
    async (rodadasGeradas) => {
      const torneioExistente = torneiosPorGrupo[grupoAtual];
      if (torneioExistente) {
        await atualizarRodadasNoBanco(torneioExistente, rodadasGeradas);
        return torneioExistente;
      }

      const novoTorneioId = await criarTorneioNoBanco(
        grupoAtual,
        rodadasGeradas,
      );
      if (novoTorneioId) {
        setTorneiosPorGrupo((prev) => ({
          ...prev,
          [grupoAtual]: novoTorneioId,
        }));
      }
      return novoTorneioId;
    },
    [grupoAtual, torneiosPorGrupo],
  );

  const rodadasView = useMemo(
    () =>
      rodadas.map((rodada, rodadaIndex) => (
        <div key={rodadaIndex} className="rodada">
          <h3 className="rodada-titulo">
            {siteTexts.challengeEngine.labels.round} {rodadaIndex + 1}
          </h3>
          {grupoAtual === "poco" &&
            rodada.length > 0 &&
            rodada.every(
              (jogo) =>
                !String(jogo.dupla1Id || "").trim() ||
                !String(jogo.dupla2Id || "").trim(),
            ) && (
              <div className="jogo jogo-pendente">
                <span className="dupla">
                  {siteTexts.challengeEngine.labels.removedPair}
                </span>
              </div>
            )}
          {rodada.map((jogo, jogoIndex) => {
            const isPendingMatch =
              grupoAtual === "poco" &&
              (!String(jogo.dupla1Id || "").trim() ||
                !String(jogo.dupla2Id || "").trim());
            if (isPendingMatch) {
              return null;
            }
            return (
              <div key={jogoIndex} className="jogo">
                <span className="dupla">
                  {duplasPorId[jogo.dupla1Id] ||
                    siteTexts.challengeEngine.labels.removedPair}
                </span>

                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={jogo.score1}
                  onChange={(e) =>
                    atualizarScore(
                      rodadaIndex,
                      jogoIndex,
                      "score1",
                      e.target.value,
                    )
                  }
                  onWheel={(e) => e.currentTarget.blur()}
                  disabled={modo === "tela"}
                />

                <span className="vs">X</span>

                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={jogo.score2}
                  onChange={(e) =>
                    atualizarScore(
                      rodadaIndex,
                      jogoIndex,
                      "score2",
                      e.target.value,
                    )
                  }
                  onWheel={(e) => e.currentTarget.blur()}
                  disabled={modo === "tela"}
                />

                <span className="dupla">
                  {duplasPorId[jogo.dupla2Id] ||
                    siteTexts.challengeEngine.labels.removedPair}
                </span>
              </div>
            );
          })}
        </div>
      )),
    [rodadas, duplasPorId, atualizarScore, modo, grupoAtual],
  );

  const desafioView = (
    <div className={`container ${classeGrupo}`}>
      <div className="overlay">
        <h1>
          <span className="titulo-principal">
            {siteTexts.challengeEngine.labels.challengeTitle}
          </span>{" "}
          - <span className="titulo-grupo">{tituloGrupo}</span>
        </h1>

        <div className="painel-topo">
          {modo === "admin" && (
            <>
              <div className="botoes-controle">
                <Button
                  variant="pill"
                  type="button"
                  onClick={iniciarCronometro}
                  disabled={cronometroAtivo || !podeIniciar}
                >
                  {siteTexts.challengeEngine.labels.start}
                </Button>
                <Button
                  variant="pill"
                  type="button"
                  onClick={finalizarPartidas}
                  disabled={!podeIniciar}
                >
                  {siteTexts.challengeEngine.labels.finish}
                </Button>
              </div>
            </>
          )}
        </div>

        {modo === "tela" && (
          <>
            <h2 className="ranking-title topo">
              {siteTexts.challengeEngine.labels.ranking}
            </h2>

            <div aria-label={siteTexts.challengeEngine.labels.ranking}>
              <table className="ranking">
                <thead>
                  <tr>
                    <th>{siteTexts.challengeEngine.labels.pos}</th>
                    <th>
                      {modoSuper8
                        ? siteTexts.challengeEngine.labels.player
                        : siteTexts.challengeEngine.labels.pair}
                    </th>
                    <th>{siteTexts.challengeEngine.labels.balance}</th>
                    <th>{siteTexts.challengeEngine.labels.matches}</th>
                    <th>{siteTexts.challengeEngine.labels.gamesWon}</th>
                    <th>{siteTexts.challengeEngine.labels.gamesLost}</th>
                    <th>{siteTexts.challengeEngine.labels.wins}</th>
                    <th>{siteTexts.challengeEngine.labels.losses}</th>
                  </tr>
                </thead>
                <tbody>
                  {ranking.map((item, index) => (
                    <tr
                      key={index}
                      className={[
                        index === 0 ? "lider" : "",
                        item.jogos < maxJogos ? "jogos-a-menos" : "",
                      ]
                        .filter(Boolean)
                        .join(" ")}
                    >
                      <td>{index + 1}</td>
                      <td>{item.label}</td>
                      <td>{item.saldoGames}</td>
                      <td>{item.jogos}</td>
                      <td>{item.gamesGanhos}</td>
                      <td>{item.gamesPerdidos}</td>
                      <td>{item.vitorias}</td>
                      <td>{item.derrotas}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}

        {modo === "admin" && (
          <div className="admin-painel">
            <div className="admin-bloco">
              <h3>
                {modoSuper8
                  ? siteTexts.challenges.modes.super8.title
                  : siteTexts.challengeEngine.labels.buildPairs}
              </h3>

              {modoSuper8 ? (
                <>
                  <div className="form-linha">
                    <input
                      list="lista-jogadores"
                      type="text"
                      placeholder={
                        siteTexts.challengeEngine.labels.playerPlaceholder
                      }
                      value={cpfJogadorSorteio}
                      onChange={(e) => setCpfJogadorSorteio(e.target.value)}
                    />
                    <Button
                      variant="primary"
                      type="button"
                      onClick={() => {
                        const cpf = normalizarDocumento(cpfJogadorSorteio);
                        if (!cpf || cpf.length < 8) return;
                        if (!cadastros[cpf]) return;

                        setJogadoresPorGrupo((prev) => {
                          const lista = prev[grupoAtual] || [];
                          const jaExiste = lista.some(
                            (jogador) => jogador.cpf === cpf,
                          );
                          if (jaExiste) return prev;
                          if (lista.length >= SUPER8_PLAYERS) {
                            window.alert(
                              "O Super 8 precisa de exatamente 8 jogadores.",
                            );
                            return prev;
                          }
                          return {
                            ...prev,
                            [grupoAtual]: [
                              ...lista,
                              {
                                cpf,
                                nome: cadastros[cpf].nome,
                                lado: { direita: true, esquerda: true },
                              },
                            ],
                          };
                        });

                        limparDuplasDoGrupo();
                        setJogosPorGrupo((prev) => ({
                          ...prev,
                          [grupoAtual]: [],
                        }));
                        setCpfJogadorSorteio("");
                      }}
                    >
                      {siteTexts.challengeEngine.labels.add}
                    </Button>
                  </div>

                  <div className="form-linha nomes-dupla">
                    <span>
                      {cadastros[normalizarDocumento(cpfJogadorSorteio)]
                        ?.nome || siteTexts.challengeEngine.labels.player}
                    </span>
                    <span className="lado-preview">
                      {jogadoresDoGrupo.length}/{SUPER8_PLAYERS}
                    </span>
                  </div>

                  <datalist id="lista-jogadores">
                    {listaJogadoresDisponiveis.map((jogador) => (
                      <option
                        key={jogador.cpf}
                        value={`${jogador.nome} - ${jogador.cpf}`}
                      />
                    ))}
                  </datalist>

                  <div className="listas-duplas">
                    <details
                      className="lista-duplas lista-duplas-collapsible"
                      open
                    >
                      <summary>
                        <h4>
                          {siteTexts.challengeEngine.labels.registeredPlayers}
                        </h4>
                      </summary>
                      {jogadoresDoGrupo.length === 0 ? (
                        <p className="vazio">
                          {siteTexts.challengeEngine.labels.nonePlayerAdded}
                        </p>
                      ) : (
                        jogadoresDoGrupo.map((jogador) => (
                          <div key={jogador.cpf} className="jogador-item">
                            <span>{jogador.nome}</span>
                            <Button
                              variant="danger"
                              type="button"
                              onClick={() => {
                                setJogadoresPorGrupo((prev) => ({
                                  ...prev,
                                  [grupoAtual]: (prev[grupoAtual] || []).filter(
                                    (item) => item.cpf !== jogador.cpf,
                                  ),
                                }));
                                limparDuplasDoGrupo();
                                setJogosPorGrupo((prev) => ({
                                  ...prev,
                                  [grupoAtual]: [],
                                }));
                              }}
                            >
                              {siteTexts.challengeEngine.labels.remove}
                            </Button>
                          </div>
                        ))
                      )}
                      <Button
                        variant="pill"
                        type="button"
                        className="gerar-rodadas"
                        disabled={
                          cronometroAtivo ||
                          jogadoresDoGrupo.length !== SUPER8_PLAYERS
                        }
                        onClick={gerarRodadasSuper8DoGrupo}
                      >
                        {siteTexts.challengeEngine.labels.generateRounds}
                      </Button>
                    </details>
                  </div>
                </>
              ) : (
                <>
                  <div className="form-linha modo-duplas">
                    <label className="modo-checkbox">
                      <input
                        type="checkbox"
                        checked={modoDuplas === "sorteadas"}
                        onChange={(e) => {
                          if (cronometroAtivo) {
                            window.alert(
                              siteTexts.challengeEngine.labels
                                .finishBeforeGeneratingRounds,
                            );
                            return;
                          }
                          resetarPartidaDoGrupo();
                          setModoDuplasPorGrupo((prev) => ({
                            ...prev,
                            [grupoAtual]: e.target.checked
                              ? "sorteadas"
                              : "fixas",
                          }));
                        }}
                      />
                      <span>
                        {siteTexts.challengeEngine.labels.pairDrawMode}
                      </span>
                    </label>
                  </div>

                  {modoDuplas === "fixas" ? (
                    <>
                      <div className="form-linha">
                        <input
                          list="lista-jogadores"
                          type="text"
                          placeholder={
                            siteTexts.challengeEngine.labels.player1Placeholder
                          }
                          value={cpfDupla1}
                          onChange={(e) => setCpfDupla1(e.target.value)}
                        />
                        <input
                          list="lista-jogadores"
                          type="text"
                          placeholder={
                            siteTexts.challengeEngine.labels.player2Placeholder
                          }
                          value={cpfDupla2}
                          onChange={(e) => setCpfDupla2(e.target.value)}
                        />
                        <Button
                          variant="primary"
                          type="button"
                          onClick={() => {
                            if (cronometroAtivo) {
                              window.alert(
                                siteTexts.challengeEngine.labels
                                  .finishBeforeGeneratingRounds,
                              );
                              return;
                            }
                            const cpf1 = normalizarDocumento(cpfDupla1);
                            const cpf2 = normalizarDocumento(cpfDupla2);
                            if (!cpf1 || !cpf2 || cpf1 === cpf2) return;
                            if (cpf1.length < 8 || cpf2.length < 8) return;
                            if (!cadastros[cpf1] || !cadastros[cpf2]) return;

                            const id = criarIdDupla(cpf1, cpf2);
                            const novaDupla = {
                              id,
                              cpf1,
                              nome1: cadastros[cpf1].nome,
                              cpf2,
                              nome2: cadastros[cpf2].nome,
                            };

                            const cpfJaSelecionado = duplas.some(
                              (dupla) =>
                                dupla.cpf1 === cpf1 ||
                                dupla.cpf2 === cpf1 ||
                                dupla.cpf1 === cpf2 ||
                                dupla.cpf2 === cpf2,
                            );
                            if (cpfJaSelecionado) {
                              window.alert(
                                siteTexts.challengeEngine.labels
                                  .playerAlreadySelected,
                              );
                              return;
                            }

                            const jaExiste = duplas.some(
                              (dupla) => dupla.id === id,
                            );
                            if (jaExiste) return;

                            resetarPartidaDoGrupo();
                            salvarDuplaNoBanco(grupoAtual, cpf1, cpf2);
                            setDuplasPorGrupo((prev) => ({
                              ...prev,
                              [grupoAtual]: [
                                ...(prev[grupoAtual] || []),
                                novaDupla,
                              ],
                            }));

                            setCpfDupla1("");
                            setCpfDupla2("");
                          }}
                        >
                          {siteTexts.challengeEngine.labels.add}
                        </Button>
                      </div>

                      <div className="form-linha nomes-dupla">
                        <span>
                          {cadastros[normalizarDocumento(cpfDupla1)]?.nome ||
                            siteTexts.challengeEngine.labels.player1}
                        </span>
                        <span>
                          {cadastros[normalizarDocumento(cpfDupla2)]?.nome ||
                            siteTexts.challengeEngine.labels.player2}
                        </span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="form-linha">
                        <input
                          list="lista-jogadores"
                          type="text"
                          placeholder={
                            siteTexts.challengeEngine.labels.playerPlaceholder
                          }
                          value={cpfJogadorSorteio}
                          onChange={(e) => {
                            const valor = e.target.value;
                            setCpfJogadorSorteio(valor);
                            const cpf = normalizarDocumento(valor);
                            const ladoSalvo = cadastros[cpf]?.lado;
                            if (ladoSalvo) {
                              const lados = normalizarLados(ladoSalvo);
                              setLadoDireita(lados.direita);
                              setLadoEsquerda(lados.esquerda);
                            }
                          }}
                        />
                        <div
                          className="lado-opcoes side-choice"
                          role="group"
                          aria-label={
                            siteTexts.challengeEngine.labels.sidePreferenceAria
                          }
                        >
                          <Button
                            type="button"
                            variant="pill"
                            className={
                              ladoDireita && !ladoEsquerda ? "active" : ""
                            }
                            onClick={() => {
                              setLadoDireita(true);
                              setLadoEsquerda(false);
                            }}
                          >
                            {siteTexts.challengeEngine.labels.right}
                          </Button>
                          <Button
                            type="button"
                            variant="pill"
                            className={
                              !ladoDireita && ladoEsquerda ? "active" : ""
                            }
                            onClick={() => {
                              setLadoDireita(false);
                              setLadoEsquerda(true);
                            }}
                          >
                            {siteTexts.challengeEngine.labels.left}
                          </Button>
                          <Button
                            type="button"
                            variant="pill"
                            className={
                              ladoDireita && ladoEsquerda ? "active" : ""
                            }
                            onClick={() => {
                              setLadoDireita(true);
                              setLadoEsquerda(true);
                            }}
                          >
                            {siteTexts.challengeEngine.labels.rightAndLeft}
                          </Button>
                        </div>
                        <Button
                          variant="primary"
                          type="button"
                          onClick={() => {
                            const cpf = normalizarDocumento(cpfJogadorSorteio);
                            if (!cpf || cpf.length < 8) return;
                            if (!cadastros[cpf]) return;
                            if (!ladoDireita && !ladoEsquerda) {
                              window.alert(
                                siteTexts.challengeEngine.selectAtLeastOneSide,
                              );
                              return;
                            }

                            setJogadoresPorGrupo((prev) => {
                              const lista = prev[grupoAtual] || [];
                              const atualizado = {
                                cpf,
                                nome: cadastros[cpf].nome,
                                lado: {
                                  direita: ladoDireita,
                                  esquerda: ladoEsquerda,
                                },
                              };
                              const jaExiste = lista.some(
                                (jogador) => jogador.cpf === cpf,
                              );
                              const novaLista = jaExiste
                                ? lista.map((jogador) =>
                                    jogador.cpf === cpf ? atualizado : jogador,
                                  )
                                : [...lista, atualizado];

                              return { ...prev, [grupoAtual]: novaLista };
                            });

                            setCadastros((prev) => ({
                              ...prev,
                              [cpf]: {
                                ...prev[cpf],
                                cpf,
                                nome: cadastros[cpf].nome,
                                lado: {
                                  direita: ladoDireita,
                                  esquerda: ladoEsquerda,
                                },
                              },
                            }));
                            salvarPreferenciaLadoNoBanco(cpf, {
                              direita: ladoDireita,
                              esquerda: ladoEsquerda,
                            });

                            limparDuplasDoGrupo();
                            setCpfJogadorSorteio("");
                          }}
                        >
                          {siteTexts.challengeEngine.labels.add}
                        </Button>
                      </div>

                      <div className="form-linha nomes-dupla">
                        <span>
                          {cadastros[normalizarDocumento(cpfJogadorSorteio)]
                            ?.nome || siteTexts.challengeEngine.labels.player}
                        </span>
                        <span className="lado-preview">
                          {formatarLados({
                            direita: ladoDireita,
                            esquerda: ladoEsquerda,
                          })}
                        </span>
                      </div>
                    </>
                  )}

                  <datalist id="lista-jogadores">
                    {listaJogadoresDisponiveis.map((jogador) => (
                      <option
                        key={jogador.cpf}
                        value={`${jogador.nome} - ${jogador.cpf}`}
                      />
                    ))}
                  </datalist>

                  <div className="listas-duplas">
                    {modoDuplas === "fixas" ? (
                      <details
                        className="lista-duplas lista-duplas-collapsible"
                        open
                      >
                        <summary>
                          <h4>
                            {siteTexts.challengeEngine.labels.registeredPairs}
                          </h4>
                        </summary>
                        {duplas.length === 0 ? (
                          <p className="vazio">
                            {
                              siteTexts.challengeEngine.labels
                                .nonePairRegistered
                            }
                          </p>
                        ) : (
                          duplasComLabel.map((dupla) => (
                            <div key={dupla.id} className="dupla-item">
                              <span>{dupla.label}</span>
                              <Button
                                variant="danger"
                                type="button"
                                onClick={() => {
                                  if (cronometroAtivo) {
                                    window.alert(
                                      siteTexts.challengeEngine.labels
                                        .finishBeforeGeneratingRounds,
                                    );
                                    return;
                                  }
                                  resetarPartidaDoGrupo();
                                  setDuplasPorGrupo((prev) => ({
                                    ...prev,
                                    [grupoAtual]: (
                                      prev[grupoAtual] || []
                                    ).filter((item) => item.id !== dupla.id),
                                  }));
                                }}
                              >
                                {siteTexts.challengeEngine.labels.remove}
                              </Button>
                            </div>
                          ))
                        )}
                        <Button
                          variant="pill"
                          type="button"
                          className="gerar-rodadas"
                          disabled={cronometroAtivo || duplas.length < 2}
                          onClick={async () => {
                            if (cronometroAtivo) {
                              window.alert(
                                siteTexts.challengeEngine.labels
                                  .finishBeforeGeneratingRounds,
                              );
                              return;
                            }
                            resetarPartidaDoGrupo();
                            const rodadasGeradas = montarRodadas(
                              duplasComLabel.map((dupla) => ({
                                id: dupla.id,
                                label: dupla.label,
                              })),
                            );

                            setJogosPorGrupo((prev) => ({
                              ...prev,
                              [grupoAtual]: rodadasGeradas,
                            }));

                            await persistirRodadasNoTorneio(rodadasGeradas);
                          }}
                        >
                          {siteTexts.challengeEngine.labels.generateRounds}
                        </Button>
                      </details>
                    ) : (
                      <>
                        <details
                          className="lista-duplas lista-duplas-collapsible"
                          open
                        >
                          <summary>
                            <h4>
                              {
                                siteTexts.challengeEngine.labels
                                  .registeredPlayers
                              }
                            </h4>
                          </summary>
                          {jogadoresDoGrupo.length === 0 ? (
                            <p className="vazio">
                              {siteTexts.challengeEngine.labels.nonePlayerAdded}
                            </p>
                          ) : (
                            jogadoresDoGrupo.map((jogador) => (
                              <div key={jogador.cpf} className="jogador-item">
                                <span>{jogador.nome}</span>
                                <span className="lado-tag">
                                  {formatarLados(jogador.lado)}
                                </span>
                                <Button
                                  variant="danger"
                                  type="button"
                                  onClick={() => {
                                    setJogadoresPorGrupo((prev) => ({
                                      ...prev,
                                      [grupoAtual]: (
                                        prev[grupoAtual] || []
                                      ).filter(
                                        (item) => item.cpf !== jogador.cpf,
                                      ),
                                    }));
                                    limparDuplasDoGrupo();
                                  }}
                                >
                                  {siteTexts.challengeEngine.labels.remove}
                                </Button>
                              </div>
                            ))
                          )}
                          <Button
                            variant="pill"
                            type="button"
                            className="gerar-rodadas"
                            disabled={
                              cronometroAtivo || jogadoresDoGrupo.length < 2
                            }
                            onClick={sortearDuplasDoGrupo}
                          >
                            {siteTexts.challengeEngine.labels.drawPairs}
                          </Button>
                        </details>

                        <details
                          className="lista-duplas lista-duplas-collapsible"
                          open
                        >
                          <summary>
                            <h4>
                              {siteTexts.challengeEngine.labels.drawedPairs}
                            </h4>
                          </summary>
                          {duplas.length === 0 ? (
                            <p className="vazio">
                              {siteTexts.challengeEngine.labels.nonePairDrawn}
                            </p>
                          ) : (
                            duplasComLabel.map((dupla) => (
                              <div key={dupla.id} className="dupla-item">
                                <span>{dupla.label}</span>
                              </div>
                            ))
                          )}
                          <Button
                            variant="pill"
                            type="button"
                            className="gerar-rodadas"
                            disabled={cronometroAtivo || duplas.length < 2}
                            onClick={async () => {
                              if (cronometroAtivo) {
                                window.alert(
                                  siteTexts.challengeEngine.labels
                                    .finishBeforeGeneratingRounds,
                                );
                                return;
                              }
                              resetarPartidaDoGrupo();
                              const rodadasGeradas = montarRodadas(
                                duplasComLabel.map((dupla) => ({
                                  id: dupla.id,
                                  label: dupla.label,
                                })),
                              );

                              setJogosPorGrupo((prev) => ({
                                ...prev,
                                [grupoAtual]: rodadasGeradas,
                              }));

                              await persistirRodadasNoTorneio(rodadasGeradas);
                            }}
                          >
                            {siteTexts.challengeEngine.labels.generateRounds}
                          </Button>
                        </details>
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {modo === "admin" && rodadas.length === 0 && (
          <p className="vazio">{mensagemVazio}</p>
        )}

        {rodadasView}

        {modo === "admin" && (
          <>
            <h2 className="ranking-title">
              {siteTexts.challengeEngine.labels.ranking}
            </h2>

            <div aria-label={siteTexts.challengeEngine.labels.ranking}>
              <table className="ranking">
                <thead>
                  <tr>
                    <th>{siteTexts.challengeEngine.labels.pos}</th>
                    <th>
                      {modoSuper8
                        ? siteTexts.challengeEngine.labels.player
                        : siteTexts.challengeEngine.labels.pair}
                    </th>
                    <th>{siteTexts.challengeEngine.labels.balance}</th>
                    <th>{siteTexts.challengeEngine.labels.matches}</th>
                    <th>{siteTexts.challengeEngine.labels.gamesWon}</th>
                    <th>{siteTexts.challengeEngine.labels.gamesLost}</th>
                    <th>{siteTexts.challengeEngine.labels.wins}</th>
                    <th>{siteTexts.challengeEngine.labels.losses}</th>
                  </tr>
                </thead>
                <tbody>
                  {ranking.map((item, index) => (
                    <tr
                      key={index}
                      className={[
                        index === 0 ? "lider" : "",
                        item.jogos < maxJogos ? "jogos-a-menos" : "",
                      ]
                        .filter(Boolean)
                        .join(" ")}
                    >
                      <td>{index + 1}</td>
                      <td>{item.label}</td>
                      <td>{item.saldoGames}</td>
                      <td>{item.jogos}</td>
                      <td>{item.gamesGanhos}</td>
                      <td>{item.gamesPerdidos}</td>
                      <td>{item.vitorias}</td>
                      <td>{item.derrotas}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );

  return desafioView;
}
